// extracted by mini-css-extract-plugin
export default {"navBar":"Navbar_navBar__afa-M","rightContainer":"Navbar_rightContainer__hZ1l1","mobileImage":"Navbar_mobileImage__OKm5p","desktopImage":"Navbar_desktopImage__uFBNA"};